export default class BaseCustomHelper {
    constructor(client) {
        this.CLIENT = client;
    }

    get client() {
        return this.CLIENT;
    }
}